import React, {
  PropsWithChildren,
  ComponentProps,
  SyntheticEvent,
} from 'react';
import { LoaderColor } from '@/ui-kit/loader';
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
} from './constants';
import { StyledButton, StyledLoader } from './styles';

interface IProps extends PropsWithChildren {
  className?: string;
  dataClass?: string;
  color?: ButtonColor;
  size?: ButtonSize;
  variant?: ButtonVariant;
  isLoading?: boolean;
  disabled?: boolean;
  type?: ComponentProps<'button'>['type'];
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void;
}

export const Button = ({
  dataClass,
  className,
  color = ButtonColor.PRIMARY,
  size = ButtonSize.MEDIUM,
  variant = ButtonVariant.BASIC,
  type = 'button',
  isLoading = false,
  disabled = false,
  onClick,
  children,
}: IProps) => {
  return (
    <StyledButton
      data-class={dataClass}
      className={className}
      color={color}
      variant={variant}
      size={size}
      type={type}
      disabled={disabled}
      isLoading={isLoading}
      onClick={isLoading ? undefined : onClick}
    >
      {children}
      {isLoading ? (
        <StyledLoader color={LoaderColor.CURRENT_COLOR} />
      ) : null}
    </StyledButton>
  );
};
